/* eslint-disable */
import React from 'react';
import { BaseFilter, ShowTitleByLowerName } from './Scaffolding';
import {
    Datagrid,
    TextField,
    Show,
    Create,
    BooleanField,
    SimpleForm,
    Edit,
    DateField,
    SimpleShowLayout,
} from 'react-admin';
import { SwList } from '../lib/SwList';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { BooleanInput, TextInput } from '../lib/wrappers/Inputs';
import { EditToolbar } from '../layout/EditToolbar';

export const AwardingBodyLabels = { pageTitle: 'Awarding Bodies' };

//TODO: Audit is not defined yet and maybe not even needed. Adding DisabledInput to avoid JSON serialization fail in Vero aPI
export const AwardingBodyList = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList
                {...props}
                title={AwardingBodyLabels.pageTitle}
                filters={<BaseFilter />}
            >
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField source="name" />
                    <BooleanField source="current" />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const AwardingBodyCreate = (props) => {
    const { canEditStaticData } = useAzureADGroups();

    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Create {...props} redirect="edit">
                <SimpleForm>
                    <TextInput disabled source="id" />
                    <TextInput source="name" />
                    <TextInput source="audit" disabled />
                    <BooleanInput source="current" />
                </SimpleForm>
            </Create>
        </ReadOnlyContext.Provider>
    );
};

export const AwardingBodyEdit = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Edit {...props} redirect="edit">
                <SimpleForm toolbar={<EditToolbar />}>
                    <TextInput disabled source="id" />
                    <TextInput source="name" />
                    <TextInput source="audit" disabled />
                    <BooleanInput source="current" />
                    <TextInput disabled source="created_at" />
                    <TextInput disabled source="updated_at" />
                </SimpleForm>
            </Edit>
        </ReadOnlyContext.Provider>
    );
};

export const AwardingBodyShow = (props) => (
    <Show title={<ShowTitleByLowerName />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="audit" />
            <BooleanField source="current" />
            <DateField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);
